// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2XirU","empty":"ModalGraph_empty__1pTvV"};